<div class="signature-backdrop"></div>
<div [ngClass]="{'zeroCopay_sign': zeroCopay}" class="signatureCapture">
    <!-- <button class="close-button" title="cancel" (click)="signatureCheck(false)">×</button> -->
    <div class="sign-header">
      <span>Please sign below: 
        <span class="required">*</span>
      </span>
      <span class="clear" (click)="clear()">Clear</span>
    </div>
    <!-- <p>Please sign below to authorize the order.</p> -->
        <canvas #canvas></canvas>
 <div class="sign-agree-check">
  <label>
    <input 
      type="checkbox"  
      (change)="onAgreeChange($event)" 
      (click)="onAgreeChange($event)" 
    />
    The above signature authorizes this purchase and serves as my legal consent.
  </label>
</div>
     <div *ngIf="zeroCopay" class="sig-actions">
    <button class="btn cancel" type="button" (click)="cancel()">Cancel</button>
    <button class="btn primary pay-now-btn" type="button" [disabled]="!signAndConsentGiven" (click)="next()">Next</button>
  </div>
</div>   
